import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BeneListService } from '../../services/beneList.service';
import { AllocatorService } from '../../services/allocator.service';
import { Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';
import { WindowService } from '../../services/window.service';

import { Beneficiary } from '../../interfaces/policy-admin-interfaces/beneficiary.interface';
import { PartyPerson } from '../../interfaces/policy-admin-interfaces/party-person.interface';
import { ModalRouteService } from '../../services/modal-route.service';

@Component({
  selector: 'bene-list',
  templateUrl: './bene-list.component.html',
  providers: [BeneListService, AllocatorService, ModalService, WindowService],
})
export class BeneListComponent implements OnInit {
  @Input() dismiss;
  @Input() policyNumber: string;
  @Input() policyType: string;

  primaryBeneList: Array<Beneficiary> = [];
  contingentBeneList: Array<Beneficiary> = [];
  currentBene: Beneficiary;

  totalPercentPrimary: number;
  totalPercentContingent: number;
  custodian;
  custodianExists: boolean = false;
  changes: boolean = false;
  hideContingent: boolean = false;
  govtId: string = '';
  policyAdminDown: boolean = false;
  channel;
  updatedPercent: boolean = false;

  public widgetType: string;

  useSecondary: boolean;
  showComplexOrTertiaryBeneMessage: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private windowService: WindowService,
    private beneListService: BeneListService,
    private allocatorService: AllocatorService,
    public modalService: ModalService,
    private modalRouteService: ModalRouteService,
    private router: Router
  ) {
    this.widgetType = this.beneListService.getChannelName();
  }

  ngOnInit(): void {
    const parentController = this.windowService.nativeWindow.controller;
    let policy;
    if (this.policyType && this.policyType === 'Term' && parentController.customer.application.isJointApp()) {
      this.policyNumber = parentController.customer.application.secondaryPolicy.policyNumber;
      policy = parentController.customer.application.secondaryPolicy;
      this.useSecondary = true;
    } else {
      this.useSecondary = false;
      policy = parentController.customer.application.primaryPolicy;
      this.policyNumber = parentController.customer.application.primaryPolicy.policyNumber;
    }
    if (parentController && parentController.customer && policy) {
      this.govtId = policy.insured.party.SSN;
    }
    if (!this.beneListService.getChanges()) {
      this.beneListService.getBeneList(this.govtId, this.useSecondary).subscribe(() => {
        this.primaryBeneList = this.beneListService.getPrimaryBeneList();
        this.contingentBeneList = this.beneListService.getContingentBeneList();

        this.custodian = this.beneListService.getCustodian();
        if (this.custodian) {
          this.custodianExists = true;
        }
        this.totalPercentPrimary = this.allocatorService.getSubTotalPrimary();
        this.totalPercentContingent = this.allocatorService.getSubTotalContingent();
        this.hideContingent = this.beneListService.hideContingent();
        this.policyAdminDown = this.beneListService.isPolicyAdminDown();
        this.showComplexOrTertiaryBeneMessage = this.beneListService.needShowComplexOrTertiaryBeneMessage();
        this.updateAll();
      });
    }
    this.channel = this.beneListService.getChannel();

    this.primaryBeneList = this.beneListService.getPrimaryBeneList();
    this.contingentBeneList = this.beneListService.getContingentBeneList();
    this.custodian = this.beneListService.getCustodian();
    this.totalPercentPrimary = this.allocatorService.getSubTotalPrimary();
    this.totalPercentContingent = this.allocatorService.getSubTotalContingent();
    this.custodian = this.beneListService.getCustodian();
    this.hideContingent = this.beneListService.hideContingent();
    if (this.custodian) {
      this.custodianExists = true;
    }

    if (!this.primaryBeneList.length) {
      this.beneListService.getBeneList(this.govtId, this.useSecondary).subscribe(() => {
        this.changes = false;
        this.primaryBeneList = this.beneListService.getPrimaryBeneList();
        this.contingentBeneList = this.beneListService.getContingentBeneList();

        this.custodian = this.beneListService.getCustodian();
        if (this.custodian) {
          this.custodianExists = true;
        }
        this.totalPercentPrimary = this.allocatorService.getSubTotalPrimary();
        this.totalPercentContingent = this.allocatorService.getSubTotalContingent();
        this.hideContingent = this.beneListService.hideContingent();
        this.updateAll();
      });
    }

    this.checkSaveButton();
  }

  updateAll(): void {
    setTimeout(() => {
      this.custodian = this.beneListService.getCustodian();
      if (this.custodian) {
        this.custodianExists = true;
      }
      this.totalPercentPrimary = this.allocatorService.getSubTotalPrimary();
      this.totalPercentContingent = this.allocatorService.getSubTotalContingent();
      this.hideContingent = this.beneListService.hideContingent();
      this.updatedPercent = true;
    }, 1000);
  }

  getBeneName(bene: Beneficiary) {
    if (bene.partyInfo) {
      const party: PartyPerson = bene.partyInfo as PartyPerson;
      return (
        bene.partyInfo.name ||
        party.person.firstName + ' ' + (party.person.middleName || '') + ' ' + (party.person.lastName || '')
      );
    } else {
      return "Insured's Children";
    }
  }
  updatePercent(bene: Beneficiary, percent, type: string): void {
    if (bene.ratio !== parseFloat(percent.target.value)) {
      if (
        percent.target.value === '' ||
        !percent.target.value ||
        isNaN(percent.target.value) ||
        parseFloat(percent.target.value) <= 0
      ) {
        //set the value back
        percent.target.value = bene.ratio;
        this.totalPercentPrimary = this.allocatorService.getSubTotalPrimary();
        this.totalPercentContingent = this.allocatorService.getSubTotalContingent();
      } else {
        this.changes = true;
        bene.ratio = parseFloat(percent.target.value);
        this.beneListService.updateBene(bene, type);
        this.totalPercentPrimary = this.allocatorService.getSubTotalPrimary();
        this.totalPercentContingent = this.allocatorService.getSubTotalContingent();
      }
    }
    this.checkSaveButton();

    this.modalRouteService.changeRoute('bene-list');

    this.updatedPercent = true;
  }

  checkSaveButton(): void {
    let disable = false;
    if (
      this.totalPercentPrimary !== 100 ||
      (this.totalPercentContingent !== 100 && this.totalPercentContingent !== 0)
    ) {
      disable = true;
    }
    if (!this.changes && !this.beneListService.getChanges()) {
      disable = true;
    }
    const submitButton: HTMLButtonElement = <HTMLButtonElement>document.getElementById('submitButton');
    if (submitButton) {
      submitButton.disabled = disable;
    }
  }

  deleteCustodian(): void {
    this.changes = true;
    this.beneListService.setCustodian(null);
    this.custodian = null;
    this.custodianExists = false;
    this.checkSaveButton();
  }

  editCustodian(): void {
    this.beneListService.setCustodian(this.custodian);
    this.modalRouteService.changeRoute('custodian');
  }

  checkCancel(): void {
    if (this.changes || this.beneListService.getChanges()) {
      this.modalService.showModal = true;
    } else {
      this.changes = false;
      this.beneListService.resetInit();
      this.beneListService.reset();
      this.dismiss();
      this.modalService.showModal = false;
      document.querySelector('body').classList.remove('modal-container__fullpage');
    }
  }

  editBene(bene: Beneficiary, type: string): void {
    this.beneListService.setCurrentBene(bene);
    this.beneListService.setPrimaryOrContingent(type);
    this.routeTo('eForm');
  }

  setBene(bene: Beneficiary): void {
    this.beneListService.setCurrentBene(bene);
  }

  deleteBeneficiary(bene: Beneficiary, type: string): void {
    this.changes = true;
    bene.action = 'deleted';
    const d = new Date();
    const actionDate = d.getMonth() + 1 + '\\' + d.getDate() + '\\' + d.getFullYear();
    bene.actionDate = actionDate;
    this.beneListService.deleteFromBeneList(bene, type);
    this.totalPercentPrimary = this.allocatorService.getSubTotalPrimary();
    this.totalPercentContingent = this.allocatorService.getSubTotalContingent();
    this.checkSaveButton();
    this.hideContingent = this.beneListService.hideContingent();
  }

  saveBenes() {
    //save the contingent and primary lists
    this.changes = false;
    if (
      (BeneListService.primaryChanged &&
        (this.beneListService.getPrimaryBeneList().length > 0 ||
          this.beneListService.getDeletedPrimaryList().length > 0)) ||
      (BeneListService.contingentChanged &&
        (this.beneListService.getContingentBeneList().length > 0 ||
          this.beneListService.getDeletedContingentList().length > 0))
    ) {
      this.beneListService.savePrimaryAndContingentBenes();
    }
    if (BeneListService.custodianChanged) {
      this.beneListService.saveCustodian();
    }

    this.beneListService.resetInit();
    this.beneListService.reset();

    this.dismiss();
    document.querySelector('body').classList.remove('modal-container__fullpage');
  }

  canEditBene(bene: Beneficiary): boolean {
    if (bene.beneficiaryType === '6' || bene.beneficiaryType === '2' || bene.beneficiaryType === '24') {
      return false;
    }
    return true;
  }

  routeTo(route: string) {
    this.modalRouteService.changeRoute(route);
  }
}
